import React from 'react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button/new';
import { messages } from '../../../../../messages';
export const NextButton = ({
  nextButtonOnClick,
  nextButtonAppearance,
  isNextButtonDisabled,
  isSubmissionLoading,
  nextButtonText,
  testId
}) => {
  const {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React.createElement(Button, {
    testId: `${testId}-footer-next-button`,
    onClick: nextButtonOnClick,
    appearance: nextButtonAppearance || 'primary',
    type: "button",
    isDisabled: isNextButtonDisabled || isSubmissionLoading,
    isLoading: isSubmissionLoading
  }, nextButtonText || formatMessage(messages.defaultNextButtonText));
};